<template>
  <div class="company">
    <div class="self-start breadcrumb">
      <el-breadcrumb class="mt-[25px] mb-[28px] ml-[2px]" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="`/company/cruise/${cruiseId}`">邮轮详情</el-breadcrumb-item>
        <el-breadcrumb-item>品牌介绍</el-breadcrumb-item>
      </el-breadcrumb> 
    </div>
    <div class="main-width">
      <company-brand-content :cruiseData="cruiseData"></company-brand-content>
      <company-brand-ship
        :company_cruise="cruiseData.company_cruise"
      ></company-brand-ship>
      <brand-back-top></brand-back-top>
    </div>
  </div>
</template>

<script>
import CompanyBrandContent from "~/views/company/CompanyBrandContent.vue";
import CompanyBrandShip from "~/views/company/CompanyBrandShip.vue";
import BrandBackTop from "@/components/layouts/BrandBackTop.vue";
import { getCruiseIntroduce } from "@/services/company";

import {
  useFetch,
  ref,
  useMeta,
  useRoute,
  defineComponent,
  computed,
} from "@nuxtjs/composition-api";
export default defineComponent({
  name: "Brand",
  layout: "Main",
  auth: false,
  components: { CompanyBrandContent, CompanyBrandShip, BrandBackTop },
  head: {},
  setup() {
    const route = useRoute();

    useMeta({
      title: "邮轮品牌",
      meta: [
        {
          name: "description",
          content:
            "【上船吧】www.shangchuanba.com，汇集全球豪华邮轮信息，提供全球邮轮信息及详细出游指南",
          hid: "description",
        }, 
        {
          name: "keywords",
          hid: "keywords",
          content: "上船吧,分销平台,境内邮轮,河轮,海轮,境外河轮,海洋邮轮,邮轮,极地邮轮",
        },
      ],
    });

    const cruiseData = ref({
      logo: "",
      name: "",
      introduction: "",
      cover: "",
      describe: "",
      company_cruise: [],
      company_introduce: [],
    });
    const execute = async () => {
      let { code, data } = await getCruiseIntroduce({ id: route.value.query.id });
      if (code != 10000) {
        return false;
      }
      cruiseData.value = data;
    };

    useFetch(async () => {
      await execute();
    });

    const cruiseId = computed(()=>{
      return route.value.query.cruiseId
    })
    return {
      cruiseData,
      cruiseId
    };
  },
});
</script>
<style lang="scss" scoped>
.main-width {
  width: 1367px;
  margin: 0 auto 15px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  -webkit-align-items: flex-start;
  align-items: flex-start;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
}
::v-deep .breadcrumb {
  width: 1190px;
  margin: 0 auto;
  font-size: 15px;
}
::v-deep .breadcrumb .is-link {
  font-weight: 500;
}
</style>
